<template>
  <div class="grid_body">
    <template v-if="hisLotteryList.length > 0">
      <q-virtual-scroll style="height: 800px;" :items="hisLotteryList" separator v-slot="{ item, index }">
        <div class="record-data grid_row" :key="index" :class='[ltTypecode == "PK10" && "fiveColumn"]'>
          <div class="grid_column" :class="[ltTypecode == 'LHC' && 'LHC_column']">{{ item.actualDrawingDate }}</div>
          <div class="grid_column" :class="[ltTypecode == 'LHC' && 'LHC_column']">{{ item.periodsNumber }}</div>
          <div class="grid_column" :class="[ltTypecode == 'LHC' && 'LHC_column']">
            <div v-if="ltTypecode == 'K3'" :class="[ltTypecode == 'K3' && 'K3No' + lotteryNum[index][i]]"
              class="openNum K3No " v-for="(items, i) in lotteryNum[index]" :key="i">
            </div>
            <div v-if="ltTypecode == '11X5'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items < 6) ? 'blueBall' : '', (f == 'dx' && items > 5) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items < 6">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 5">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
            <div v-if="ltTypecode == '3D'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items <= 4) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items <= 4">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 4">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
            <div v-if="ltTypecode == 'LHC'" class="openNum" v-for="(items, i) in lotteryNum[index]" :class="[
                    (f == 'dx' && items < 26) ? 'blueBall' : '',
                    (f == 'dx' && items > 25) ? 'redBall' : '',
                    (f == 'ds' && items % 2 == 0) ? 'redBall' : '',
                    (f == 'ds' && items % 2 != 0) ? 'blueBall' : '',
                    (f == 'num') ? 'lhc' + findNumbColor(items) : ''
                  ]" v-show="i + 1 != lotteryNum[index].length && 'true'" :key="i">
              <template v-if="f == 'dx' && items < 25">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 24">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
              <div class="animals">
                {{ findNumbAnimal(items, getAnimalList(item.periodsNumber)) }}
              </div>
            </div>
            <div v-if="ltTypecode == 'LHC'" class="openNum noBackground ">
              +
            </div>
            <div v-if="ltTypecode == 'LHC'" class="openNum" :class="[
      (f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] < 26) ? 'blueBall' : '',
      (f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] > 25) ? 'redBall' : '',
      (f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 == 0) ? 'redBall' : '',
      (f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 != 0) ? 'blueBall' : '',
      (f == 'num') ? 'lhc' + findNumbColor(lotteryNum[index][lotteryNum[index].length - 1]) : ''
    ]">
              <template v-if="f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] < 25">
                小
              </template>
              <template v-else-if="f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] > 24">
                大
              </template>
              <template v-else-if="f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 != 0">
                单
              </template>
              <template v-else>
                {{ lotteryNum[index][lotteryNum[index].length - 1] }}
              </template>
              <div class="animals">
                {{ findNumbAnimal(lotteryNum[index][lotteryNum[index].length - 1], getAnimalList(item.periodsNumber)) }}
              </div>
            </div>
            <div v-if="ltTypecode == 'PK10'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items <= 5) ? 'blueBall' : '', (f == 'dx' && items > 5) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items <= 5">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 5">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
            <div v-if="ltTypecode == 'PL3'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items < 5) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items < 5">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 4">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
            <div v-if="ltTypecode == 'SSC'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items < 5) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items < 5">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 4">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
            <div v-if="ltTypecode == 'ZHISHU'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items <= 4) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items <= 4">
                跌
              </template>
              <template v-else-if="f == 'dx' && items > 4">
                涨
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
            <div v-if="ltTypecode == 'SSQ'" class="openNum lhcred" v-for="(items, i) in lotteryNum[index]" :key="i"
              v-show="i + 1 != lotteryNum[index].length && 'true'">
              <div>
                {{ items }}
              </div>
            </div>
            <div v-if="ltTypecode == 'SSQ'" class="openNum noBackground ">
              +
            </div>
            <div v-if="ltTypecode == 'SSQ'" class="openNum lhcblue">
              <div>
                {{ lotteryNum[index][lotteryNum[index].length - 1] }}
              </div>
            </div>
            <div v-if="ltTypecode == 'DLT'" class="openNum lhcred" v-for="(items, i) in lotteryNum[index].slice(0, 5)"
              :key="i">
              <div>
                {{ items }}
              </div>
            </div>
            <div v-if="ltTypecode == 'DLT'" class="openNum noBackground ">
              +
            </div>
            <div v-if="ltTypecode == 'DLT'" class="openNum lhcblue">
              <div>
                {{ lotteryNum[index][lotteryNum[index].length - 2] }}
              </div>
            </div>
            <div v-if="ltTypecode == 'DLT'" class="openNum lhcblue">
              <div>
                {{ lotteryNum[index][lotteryNum[index].length - 1] }}
              </div>
            </div>
            <div v-if="ltTypecode == 'PCDD'" class="openNum" v-for="(items, i) in lotteryNum[index]"
              :class="[(f == 'dx' && items < 5) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
              :key="i">
              <template v-if="f == 'dx' && items < 5">
                小
              </template>
              <template v-else-if="f == 'dx' && items > 4">
                大
              </template>
              <template v-else-if="f == 'ds' && items % 2 == 0">
                双
              </template>
              <template v-else-if="f == 'ds' && items % 2 != 0">
                单
              </template>
              <template v-else>
                {{ items }}
              </template>
            </div>
          </div>
          <div :class="[ltTypecode == '3D' && 'threeGrid', ltTypecode == '11X5' && 'threeGrid', ltTypecode == 'K3' && 'threeGrid', ltTypecode == 'LHC' && 'normalGrid LHC_height', ltTypecode == 'PK10' && 'tigerDragonGrid', ltTypecode == 'PL3' && 'threeGrid', ltTypecode == 'SSC' && 'threeGrid', ltTypecode == 'ZHISHU' && 'oneGrid', ltTypecode == 'SSQ' && 'twoGrid', ltTypecode == 'DLT' && 'twoGrid', ltTypecode == 'PCDD' && 'threeGrid']
      ">
            <div v-for="(items, i) in addAll[index]" :key v-if="ltTypecode != 'ZHISHU'">
              {{ items }}
            </div>
            <div v-if="ltTypecode == 'ZHISHU'">
              {{ zhishuNiuonXiong[index].join('') }}
            </div>
          </div>
          <div class="grid_column" v-if="ltTypecode == 'PK10'">
            {{ sscDragonTigerpk[index].join('') }}
          </div>
        </div>
      </q-virtual-scroll>
    </template>
    <template v-else-if="historyrecord">
      <div class="empty">
        <div data-v-3ba12b9b="" class="wrap-svg">
          <img src="../../assets/pc_empty_state.svg">
          <div class="empty">暂无记录</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wrap-loading">
        <div class="notContent">
          <img src="../../assets/icon_loading.svg">
          <div class="ball-shadow"></div>
          <p>资料加载中</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import lhcMixins from '~/mixins/lhc.mixins'
export default {
  mixins: [lhcMixins],
  data() {
    return {
      lotteryTypecode: '',
      lotterycode: '',
      loading: false
    }
  },
  props: {
    ltTypecode: {
      type: [String],
      default: "home"
    },
    f: {
      type: [String],
      default: "num"
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.loading = true;
        this.lotteryTypecode = this.$route.query.lotteryTypeCode;
        this.lotterycode = this.$route.query.lotteryCode;
        this.$store.commit(
          "lottery/setlotteryTypeCode",
          this.lotteryTypecode
        );
        this.$store.commit(
          "lottery/setHisLotteryList", []
        );
        this.$store.commit("lottery/setlotteryCode", this.lotterycode);
        this.$store.commit(
          "lottery/setHisLotteryList", []
        );
        this.$store.dispatch("lottery/queryHisPeriodsPage")
      },
      immediate: true,
      deep: true
    },
    "lottery.status"() {
      console.log("倒计时lottery.status改变");
    },
  },
  computed: {
    // 1-5龙虎(arr[arr])
    sscDragonTigerpk() {
      return this.$store.state.lottery.sscDragonTigerpk
    },
    // 指数牛熊
    zhishuNiuonXiong() {
      return this.$store.state.lottery.zhishuNiuonXiong
    },
    addAll() {
      return this.$store.state.lottery.addAll
    },
    // 开奖历史
    hisLotteryList() {
      return this.$store.state.lottery.hisLotteryList;
    },
    // 开奖号码(arr[arr])
    lotteryNum() {
      return this.$store.state.lottery.lotteryNum;
    },
    // 
    historyrecord() {
      return this.$store.state.lottery.historyrecord;
    },
  },
  methods: {
    getAnimalList(periodsNumber) {
      return this.getCurrYearAnimal(periodsNumber.slice(0, 4));
    }
  }
}
</script>
<style lang="less">
.grid_body {
  height: 550px;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;

  .wrap-loading {
    margin-top: 150px;

    .notContent {
      text-align: center;
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    font-size: 14px;

    .grid_container {
      font-size: 14px
    }

    .wrap-svg {
      margin-top: 100px
    }

    .empty {
      margin-bottom: 67px
    }
  }

  .q-list {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .LHC_column {
    height: 70px !important;
  }

  .grid_column {
    border-bottom: 1px solid #d3d3d3;
    border-right: 1px solid #d3d3d3;
    place-content: center;
    display: grid;
    grid-auto-flow: column;
    height: 50px;

    .openNum {
      display: grid;
      place-items: center;
      width: 36px;
      height: 36px;
      background: #e5e2f3;
      border-radius: 100%;
      margin-right: 12px;
      position: relative;

      .animals {
        position: absolute;
        bottom: -23px;
      }
    }

    .noBackground {
      background: hsla(0, 0%, 100%, 0);
    }

    .lhcred {
      background: #f7dfdf;
    }

    .lhcblue {
      background: #deeaf0;
    }

    .lhcgreen {
      background: #d3e8d2;
    }

    .blueBall {
      background: #deeaf0;
    }

    .redBall {
      background: #f7dfdf;
    }

    .K3No {
      background: url(../../assets/open_num.png) no-repeat center 0;
      background-size: cover;
      border-radius: 0;
      margin-top: 3px
    }

    .K3No1 {
      background-position: 50% 1%
    }

    .K3No2 {
      background-position: 50% 17.79%
    }

    .K3No3 {
      background-position: 50% 34.232%
    }

    .K3No4 {
      background-position: 50% 50.974%
    }

    .K3No5 {
      background-position: 50% 67.616%
    }

    .K3No6 {
      background-position: 50% 84.4%
    }
  }

  .threeGrid {
    display: grid;
    grid-auto-flow: column;
    border-right: 1px solid #d3d3d3;
  }

  .normalGrid {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(4, 54px);
    border-right: 1px solid #d3d3d3;
  }

  .normalGrid>div {
    height: 50px;
    align-items: center;
    justify-items: center;
    display: grid;
    border-bottom: 1px solid #d3d3d3;
  }

  .normalGrid>div:first-child {
    border-right: 1px solid #d3d3d3;
    height: 50px;
  }

  .normalGrid>div:nth-child(2) {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .normalGrid>div:nth-child(3) {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .oneGrid {
    border-bottom: 1px solid #d3d3d3;
    line-height: 50px;
    text-align: center;
  }

  .oneGrid>div {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .twoGrid {
    border-bottom: 1px solid #d3d3d3;
    display: flex;
    grid-auto-flow: column;
  }

  .twoGrid>div:first-child,
  .twoGrid>div:nth-child(2) {
    border-right: 1px solid #d3d3d3;
    flex: 1;
    height: 50px;
    text-align: center;
    line-height: 50px;
  }

  .oneGrid>div {
    border-right: 1px solid #d3d3d3;
    align-items: center;
    justify-items: center;
    display: grid;
  }

  .threeGrid>div {
    align-items: center;
    justify-items: center;
    display: grid;
    width: 72px;
    border-bottom: 1px solid #d3d3d3;
  }

  .threeGrid>div:first-child {
    border-right: 1px solid #d3d3d3;
    height: 50px;
  }

  .threeGrid>div:nth-child(2) {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .tigerDragonGrid {
    display: grid;
    grid-auto-flow: column
  }

  .tigerDragonGrid>div {
    align-items: center;
    justify-items: center;
    display: grid;
    width: 48px;
    border-bottom: 1px solid #d3d3d3;
  }

  .tigerDragonGrid>div:first-child,
  .tigerDragonGrid>div:nth-child(2),
  .tigerDragonGrid>div:nth-child(3) {
    height: 50px;
    border-right: 1px solid #d3d3d3;
  }

  .LHC_height div:first-child,
  .LHC_height div:nth-child(2),
  .LHC_height div:nth-child(3),
  .LHC_height div:nth-child(4),
  .LHC_height {
    height: 70px !important
  }

  .LHC_column .openNum {
    top: -9px;
  }

  .record-data {
    display: grid;
    grid-template-columns: 180px 140px 2fr 219px;
    border-left: 1px solid #d3d3d3;
  }

  .fiveColumn {
    grid-template-columns: 180px 140px 2fr 147px 133px
  }

  .record-data:hover {
    background: #fff8ec
  }
}
</style>